module.exports = __webpack_public_path__ + "static/media/favicon.0ed80278.ico";